import { useState, useEffect } from "react";

// @mui material components
import VerifiedIcon from "@mui/icons-material/Verified";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { IoMenu } from "react-icons/io5";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiProgress from "components/VuiProgress";
import VuiOpenLink from "components/VuiOpenLink";
import VuiLoading from "components/VuiLoading";
import VuiLabel from "components/VuiLabel";

import moment from "moment";
import api from "services/api";
import useWindowDimensions from "hooks/useWindowDimensions";

import VuiInfoItemLink from "components/VuiInfoItemLink";

import colors from "assets/theme/base/colors";

// Function randomInt(min, max)
// min and max included
function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function DashUsers() {
  const userLogged = JSON.parse(localStorage.getItem("user"));
  const { height, width } = useWindowDimensions();
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [refreshInterval, setRefreshInterval] = useState(60000);
  const [countAllUnits, setCountAllUnits] = useState(0);
  const [usersEnabled, setUserEnabled] = useState(0);
  const [usersActived, setUserActived] = useState(0);

  async function loadLinks() {
    setLoading(true);
    const res = await api.get(`users`);
    console.log(">>> DashUsers:userLogged", userLogged, res.data.data);

    setCountAllUnits(res.data.data.length);
    setUserEnabled(res.data.data.filter((i) => i.activated).length);
    setUserActived(res.data.data.filter((i) => i.enabled).length);

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }

  useEffect(() => {
    loadLinks();
  }, [false]);

  useEffect(() => {
    if (refreshInterval && refreshInterval > 0) {
      const interval = setInterval(loadLinks, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [refreshInterval]);

  return (
    <>
      {loading ? (
        <VuiLoading />
      ) : (
        <div>
          <VuiBox display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
            <IoMenu size={32} style={{ marginRight: 10 }} />
            <VuiLabel
              title={`Usuários do Sistema`}
              colorTitle="warning"
              fontWeight="bold"
              sizeTitle={24}
            />
          </VuiBox>

          <div
            style={{
              display: "grid",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginBottom: 20,
            }}
          >
            <VuiBox display={"flex"} flexDirection={"column"} justifyContent={"flex-end"}>
              <VuiBox
                display={"flex"}
                flexDirection={"rows"}
                justifyContent={"flex-end"}
                alignItems={"center"}
              >
                <VerifiedIcon fontSize="medium" color="success" />
                <VuiOpenLink
                  colorTitle={"success"}
                  title={`Total de Usuários ${countAllUnits}`}
                  url="usersView?search=online"
                />
              </VuiBox>
              <VuiLabel
                sizeTitle={18}
                colorTitle={"warning"}
                title={`Usuários desativados ${usersActived} e habilitados ${usersEnabled}`}
              />
            </VuiBox>
          </div>
        </div>
      )}
    </>
  );
}

export default DashUsers;
